/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css, cx } from "@panda/css";
import { Box, BoxProps } from "@panda/jsx";

export type ArticleWidthSizes = "" | "unbound" | "sm" | "md" | "lg";

export interface ArticleChildrenWrapProps extends BoxProps {
	disable?: boolean;
	children?: React.ReactNode;
	className?: string;
	size?: ArticleWidthSizes;
}

const styles = css({
	position: "relative",
	marginInline: "auto",
	width: "100%",
	smDown: {
		maxWidth: "100%",
	},
});

export const articleSmStyles = css({
	maxWidth: `cosmos.article.sm`,
});

export const articleMdStyles = css({
	maxWidth: `cosmos.article.md`,
});

export const articleLgStyles = css({
	maxWidth: `cosmos.article.lg`,
});

export const ArticleChildrenWrap = ({
	disable,
	className = "",
	children,
	size = "sm",
	...rest
}: ArticleChildrenWrapProps): React.ReactNode => {
	if (disable) {
		return children;
	}

	return (
		<Box
			className={cx(
				"article-children-wrap",
				styles,
				className,
				size,
				size === "sm" ? articleSmStyles : null,
				size === "md" ? articleMdStyles : null,
				size === "lg" ? articleLgStyles : null,
			)}
			{...rest}
		>
			{children}
		</Box>
	);
};
